var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTranslate = function SvgTranslate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F3F46",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.5 4.167h3.333m0 0h3.334A6.664 6.664 0 0 1 5.833 9.94m0-5.774V2.5m0 7.441a6.636 6.636 0 0 1-3.333.892m3.333-.892A6.7 6.7 0 0 1 3.392 7.5m2.441 2.441c.98.568 2.12.892 3.334.892M17.5 17.5v-.052c0-.828-.088-1.648-.258-2.448m-6.409 2.5v-.052c0-.828.088-1.648.258-2.448m0 0a11.728 11.728 0 0 1 2.313-4.88.977.977 0 0 1 1.526 0A11.73 11.73 0 0 1 17.242 15m-6.15 0h6.15"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTranslate);
export default ForwardRef;